import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {HistoryTabModel} from "../history.tab-model";
import {CompetitionHistoryPageLinkModel} from "../../../../../containers/competition-container/pages/history-page/models/competition-history-page.link-model";

export class CompetitionHistoryPageTabModel extends HistoryTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel,
    isWidget: BaseLinkModel
  ) {
    super(index, name, isWidget)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitionHistoryPageLinkModel {
    const linkModel: CompetitionHistoryPageLinkModel = new CompetitionHistoryPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.history;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_history';
  }
}
